<template>
  <div>
      <div class="columns">
          <div class="column has-text-centered">
              <h1 class="has-text-white is-size-3">ITEM MANAGER</h1>
          </div>
      </div>
      <div class="columns">
          <div class="column">
              <section class="section">
                <b-field grouped group-multiline>
                <b-button class="is-dvogreen mb-4" @click="addItemModal()">Add New Item</b-button>
                </b-field>
                <b-table 
                    :data="items" 
                   :loading="loading"
                    :total="total"
                    paginated
                    backend-pagination
                    :per-page="perPage" 
                    @page-change="onPageChange"
                    :current-page.sync="currentPage"
                    :pagination-simple="false" 
                    pagination-position="bottom" 
                    striped
                    >
                    <b-table-column field="serial" label="Serial #" width="40" v-slot="props">
                        {{ props.row.serial }}
                    </b-table-column>
                    <b-table-column label="Owner Name" width="40" v-slot="props">
                        {{ props.row.first_name }} {{ props.row.last_name}}
                    </b-table-column>
                    <b-table-column field="product_id" label="Product Code" width="40" v-slot="props">
                        {{ props.row.product_id }}
                    </b-table-column>
                    <b-table-column field="description" label="Description of Product" width="50" v-slot="props">
                        {{ props.row.product_id }}
                    </b-table-column>
                    <b-table-column field="date_purchase" label="Date of Purchase" width="40" v-slot="props">
                        {{ new Date(props.row.date_purchase).toLocaleDateString() }}
                    </b-table-column>
                    <b-table-column field="date_production" label="Date of Production" width="40"
                        v-slot="props">
                        {{ new Date(props.row.date_production) }}
                    </b-table-column>
                    <b-table-column label="Delete" width="10" v-slot="props">
                        <i @click="deleteItem(props.row.serial)" class="far fa-trash-alt has-text-dvogreen"></i>
                    </b-table-column>
                    <b-table-column label="Update" width="10" v-slot="props">
                        <i @click="updateItemModal(props.row.serial, props.row.person_id, props.row.product_id, props.row.date_purchase, props.row.date_production)"
                            class="fas fa-edit has-text-dvogreen"></i>
                    </b-table-column>
                </b-table>
              </section>
          </div>
      </div>
  </div>
</template>

<script>
import { API  } from 'aws-amplify'
import { itemHandler } from '../graphql/mutations'
import { getItemsWithPerson, getItemCount } from '../graphql/queries'
import AddItem from './AddItem.vue'
import UpdateItemModal from './UpdateItemModal.vue'

export default {
    data() {
        return {
            items: [],
            currentPage: 1,
            perPage: 20,
            loading: false,
            total: null,
            page: 1
        }
    },
    components:{

    },
    methods: {
        async getItems() {
            this.loading = true
            try {
            const Items = await API.graphql({
                query: getItemsWithPerson,
                variables: {
                    input: {
                        request_type: 'read_all_with_person',
                        limit: this.perPage,
                        page: this.page
                    }
                }
            });
            this.items = Items.data.getItemsWithPerson;
            } catch (e) {
                    this.$buefy.notification.open({
                    duration: 5000,
                    message: `${e}`,
                    position: 'is-bottom',
                    type: 'is-danger',
                    hasIcon: true
                })
            }
            this.loading = false
        },
        addItemModal() {
            this.$buefy.modal.open({
                parent: this,
                component: AddItem,
                hasModalCard: true,
                trapFocus: true,
                props: {

                },
                events: {
                    'close': value => {
                        console.log(value)
                        this.getItems();
                    }
                }
            })
        },
        async deleteItem(serial) {
            const inputSerial = serial
            const apiReturn = await API.graphql({
                query: itemHandler,
                variables: {
                    input: {
                        request_type: 'delete',
                        serial: inputSerial
                    }
                }
            });
            const temp = apiReturn.data.itemHandler
            this.items = this.items.filter(obj => obj.serial != temp.serial);
        },
        updateItemModal(serial, person_id, product_id, date_of_purchase, date_of_production) {
            this.$buefy.modal.open({
                parent: this,
                component: UpdateItemModal,
                hasModalCard: true,
                trapFocus: true,
                props: {
                    initSerial: serial,
                    initPersonId: person_id,
                    initProductId: product_id,
                    initDateOfPurchase: date_of_purchase,
                    initDateOfProduction: date_of_production,
                },
                events: {
                    'close': value => {
                        console.log(value)
                        this.getItems()
                    }
                }
            })
        },
        async getTotal(){
        const Items = await API.graphql({
                query: getItemCount,
                variables: {
                    input: {
                        request_type: 'get_count'
                    }
                }
            });
        this.total = Items.data.getItemCount.daily;
        },
        onPageChange(page) {
            this.page = page
            this.getItems()
        },
    },
    mounted() {
        this.getTotal();
        this.getItems();
    }
}
</script>

<style>
</style>